(() => {
    const header = document.getElementById('site-header');
    const toggle = document.getElementById('menu-toggle');
    const nav = document.querySelector('.site-header__nav');
    const body = document.body;

    const hero = document.querySelector('.menu-go');

    const updateScrollState = () => {
        if (!hero) return;

        const y = window.scrollY || window.pageYOffset;
        const heroRect = hero.getBoundingClientRect();
        const heroBottom = y + heroRect.top + heroRect.height;

        const pastHero = y >= heroBottom;
        if (pastHero || header.classList.contains('is-open')) {
            header.classList.add('is-scrolled');
        } else {
            header.classList.remove('is-scrolled');
        }
    };

    updateScrollState();
    window.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState);

    toggle.addEventListener('click', () => {
        const open = header.classList.toggle('is-open');
        body.classList.toggle('body--lock', open);
        if (open) header.classList.add('is-scrolled');
        else updateScrollState();
    });

    const initAccordion = () => {
        if (!nav) return;

        const toggles = nav.querySelectorAll('.menu-toggle-btn--root');

        toggles.forEach(t => {
            const li = t.closest('li.menu-item-has-children');

            const toggleBranch = () => {
                const willExpand = !li.classList.contains('is-expanded');

                li.classList.toggle('is-expanded', willExpand);
                li.querySelectorAll('li.menu-item-has-children').forEach(child => {
                    child.classList.toggle('is-expanded', willExpand);
                });
            };

            t.addEventListener('click', (e) => { e.preventDefault(); toggleBranch(); });
            t.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleBranch(); }
            });
        });
    };
    initAccordion();
})();
